import React, { useState } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

const LoginForm = () => {
      const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (!email || !password) {
            setError('Please fill in both fields');
        } else {
            // Here you can handle form submission
           if(password === "Te$t@123") {
            setError('');
            let username: string = email?.length > 0 && email?.indexOf('@') > 0 ? email?.split('@')[0] : "";
            username = username?.indexOf('.') > 0 ? `${username?.split(".")[0]} ${username?.split(".")[1]}` : username;
            const userInfo: any = {
                username,
                email,
            }
            sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
            navigate("/c-dad")
           } else {
            setError('Username and/or password you entered is incorrect');
           }
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    
                />
                <TextField
                    fullWidth
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    variant="outlined"
                    margin="normal"
                />
                  {error && (
                <Typography color="error" align="center" sx={{ marginBottom: 2 }}>
                    {error}
                </Typography>
            )}
                <div
                style={{ marginTop: '3rem' }}
                >
                <Button
                    type="submit"

                    sx={{
                        borderRadius: 50,
                        px: 2,
                        color: "black",
                        borderColor: "black",
                    }}
                    variant="outlined"
                >
                    LOGIN
                </Button>
                </div>
            </form>
        </>
    );
};

export default LoginForm;
